import {
    UPDATE_JOB_FIELD_FOR_CUSTOMER_EDIT,
    FETCH_JOB_FOR_CUSTOMER_EDIT,
    INIT_ROLE_DATA_FOR_CUSTOMER_EDIT,
} from '../actions/EditJobRequest';

import { defaultRoleData } from '../components/common/Utils';

const initialState = {
    originalJobData: {},
    jobData: {},
    roleData: defaultRoleData,
};

export default function(state = initialState, action) {
    const newState = JSON.parse(JSON.stringify(state));
    // eslint-disable-next-line default-case
    switch (action.type) {
        case FETCH_JOB_FOR_CUSTOMER_EDIT:
            newState.jobData = action.payload;
            newState.originalJobData = action.payload;
            return newState;
        case UPDATE_JOB_FIELD_FOR_CUSTOMER_EDIT:
            newState.jobData[action.payload.field] = action.payload.data;
            return newState;
        case INIT_ROLE_DATA_FOR_CUSTOMER_EDIT:
            newState.roleData = action.payload;
            return newState;
    }
    return state;
}
